import { IIcon } from "components/icons/icons.types";
import React from "react";

const VideoIcon: React.FC<IIcon> = ({
  width = "16",
  height = "16",
  color = "currentColor"
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 0H11C12.6569 0 14 1.34315 14 3V10C14 11.6569 12.6569 13 11 13H3C1.34315 13 0 11.6569 0 10V3C0 1.34315 1.34315 0 3 0ZM19.05 11.2803L16.05 9.78026C15.8836 9.6964 15.7439 9.5677 15.6467 9.40867C15.5495 9.24965 15.4987 9.06663 15.5 8.88026V4.12027C15.4987 3.9339 15.5495 3.75088 15.6467 3.59186C15.7439 3.43283 15.8836 3.30413 16.05 3.22026L19.05 1.72026C19.203 1.64317 19.3732 1.60667 19.5444 1.61426C19.7155 1.62186 19.8819 1.6733 20.0274 1.76364C20.173 1.85399 20.2929 1.98021 20.3756 2.13021C20.4584 2.28021 20.5012 2.44895 20.5 2.62027V10.3803C20.5012 10.5516 20.4584 10.7203 20.3756 10.8703C20.2929 11.0203 20.173 11.1465 20.0274 11.2369C19.8819 11.3272 19.7155 11.3787 19.5444 11.3863C19.3732 11.3939 19.203 11.3574 19.05 11.2803Z"
        fill={color}
      />
    </svg>
  );
};

export { VideoIcon };
